import React from "react";

const defaultLegalActions = [
  {
    type: "Penalty/Fine",
    ngrbc: "",
    agency: "",
    amount: "",
    brief: "",
    appeal: false,
  },
  {
    type: "Settlement",
    ngrbc: "",
    agency: "",
    amount: "",
    brief: "",
    appeal: false,
  },
  {
    type: "Compounding fee",
    ngrbc: "",
    agency: "",
    amount: "",
    brief: "",
    appeal: false,
  },
  {
    type: "Imprisonment",
    ngrbc: "",
    agency: "",
    amount: "",
    brief: "",
    appeal: false,
  },
  {
    type: "Punishment",
    ngrbc: "",
    agency: "",
    amount: "",
    brief: "",
    appeal: false,
  },
];

const LegalActionsTable = ({ legalData, setLegalData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...legalData];
    updated[index][field] = value;
    setLegalData(updated);
  };

  const toggleAppeal = (index) => {
    const updated = [...legalData];
    updated[index].appeal = !updated[index].appeal;
    setLegalData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Type</th>
            <th style={tableHeaderStyle}>NGRBC Principle</th>
            <th style={tableHeaderStyle}>
              Name of the Regulatory/Enforcement Agencies/ Judicial instructions
            </th>
            <th style={tableHeaderStyle}>Amount (in INR)</th>
            <th style={tableHeaderStyle}>Brief of the Case</th>
            <th style={tableHeaderStyle}>Has an appeal been preferred?</th>
          </tr>
        </thead>
        <tbody>
          {legalData.map((row, index) => (
            <tr key={index}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.type}
              </td>

              {/* NGRBC */}
              <td style={tableCellStyle}>
                <textarea
                  placeholder="Enter NGRBC principle"
                  value={row.ngrbc}
                  onChange={(e) => handleChange(index, "ngrbc", e.target.value)}
                  style={textareaStyle}
                />
              </td>

              {/* Agency */}
              <td style={tableCellStyle}>
                <textarea
                  placeholder="Enter Name"
                  value={row.agency}
                  onChange={(e) =>
                    handleChange(index, "agency", e.target.value)
                  }
                  style={textareaStyle}
                />
              </td>

              {/* Amount */}
              <td style={tableCellStyle}>
                <textarea
                  placeholder="Enter Amount"
                  value={row.amount}
                  onChange={(e) =>
                    handleChange(index, "amount", e.target.value)
                  }
                  style={textareaStyle}
                />
              </td>

              {/* Brief */}
              <td style={tableCellStyle}>
                <textarea
                  placeholder="Brief of case"
                  value={row.brief}
                  onChange={(e) => handleChange(index, "brief", e.target.value)}
                  style={textareaStyle}
                />
              </td>

              {/* Appeal Toggle */}
              <td style={tableCellStyle}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <span>No</span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={row.appeal}
                      onChange={() => toggleAppeal(index)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span>Yes</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Toggle Switch CSS */}
      <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 44px;
          height: 22px;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 24px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }

        input:checked + .slider {
          background-color: #8a4a68;
        }

        input:checked + .slider:before {
          transform: translateX(22px);
        }
      `}</style>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const textareaStyle = {
  width: "100%",
  height: "80px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

export default LegalActionsTable;
